import type { Pill } from "@npco/zeller-design-system";
import * as Icon from "@npco/zeller-design-system/icon";

import { Source } from "../../../../../schema.dev-sdk-api-appsync.generated";

const icon = <Icon.Pos />;

export namespace GetBadgeProperties {
	export type Props = {
		isPaired: boolean;
		source?: Source;
		sourceName?: string;
	};
}

export function getBadgeProperties({
	isPaired,
	source,
	sourceName,
}: GetBadgeProperties.Props): Pill.Props {
	if (isPaired) {
		return { label: "Paired to this device", color: "grey", icon };
	}

	switch (source) {
		// unpaired terminals are defined as STANDALONE
		case Source.STANDALONE:
			return { label: "Available", color: "grey" };
		// only LINKLY pos pairings return source name if provided
		// fallback to default defined above for SDK
		case Source.SDK:
		case Source.LINKLY:
			return {
				label: sourceName ? sourceName : "Paired",
				color: "green",
				icon,
			};
		case Source.TEVALIS_POS:
			return { label: "Tevalis Pay at Table", color: "green", icon };
		case Source.IMPOS:
			return { label: "Impos Pay at Table", color: "green", icon };
		case Source.HL_POS:
			return { label: "H&L Pay at Table", color: "green", icon };
		case Source.ORACLE_POS:
			return { label: "Oracle Symphony", color: "green", icon };
		case Source.ZELLER_POS:
			return { label: "Zeller Point of Sale", color: "green", icon };
		default:
			return { label: "Other Point of Sale", color: "green", icon };
	}
}
